import type { TFunction } from 'i18next'
import { ApiError } from '@/services/baseService'

export function resolveApiErrorMessage(error: unknown, t: TFunction<'errors'>): string {
  if (error instanceof ApiError) {
    if (error.code) {
      const translated = t(error.code, { defaultValue: '' })
      if (translated) {
        return translated
      }
    }
    if (error.message) {
      return error.message
    }
  }
  if (error instanceof Error && error.message) {
    return error.message
  }
  return t('generic')
}
